import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useState } from "react";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useQueryClient } from "@tanstack/react-query";
import { TrashIcon } from "lucide-react";
import { useDeleteGovernmentAllocationDistributionLimit } from "@/features/privateCompanies/hooks/governmentAllocations/distributionsLimits/useDeleteGovernmentAllocationDistributionLimit";

interface DeleteDistributionLimitProps {
  governmentAllocationId?: string;
  productCategoryDistributionLimitId: string;
}

const DeleteDistributionLimit = ({
  governmentAllocationId,
  productCategoryDistributionLimitId,
}: DeleteDistributionLimitProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteGovernmentAllocationDistributionLimit,
    isPending: deleteGovernmentAllocationDistributionLimitIsPending,
  } = useDeleteGovernmentAllocationDistributionLimit({
    governmentAllocationId,
    productCategoryDistributionLimitId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributionsLimits', governmentAllocationId] });
      queryClient.invalidateQueries({ queryKey: ['governmentAllocation', governmentAllocationId] });

      setIsOpen(false);
    },
    onError: (error) => {
      FormTransformers.errorsTransformer({ setMessages })(error);
    }
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            operationKlassToCheckPermission="Admin::Billing::GovernmentAllocations::UpdateDistributionLimits"
            variant="link"
          >
            <TrashIcon strokeWidth={1} className="text-danger-soft" />
          </Button>
        )}
        bodyClassName='max-h-[calc(90vh-72px-48px)] overflow-auto'
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        useCancellableFooter
        cancelButtonClassName="bg-white-100 rounded-es-lg"
        confirmButtonClassName="rounded-ee-lg"
        showClose={false}
        disabled={deleteGovernmentAllocationDistributionLimitIsPending}
        onConfirm={deleteGovernmentAllocationDistributionLimit}
        confirmButtonIsLoading={deleteGovernmentAllocationDistributionLimitIsPending}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DeleteDistributionLimit;
